import clsx from 'clsx';

interface TabsProps {
  tabs: ReadonlyArray<{ id: string; label: string }>;
  active: string;
  onChange: (id: string) => void;
  className?: string;
}

/**
 * Lightweight tab bar (bar only — no panel management). Consumers keep every
 * panel mounted and toggle `hidden`, so heavy content (e.g. the reviewer's PDF
 * canvas) never unmounts on tab switch.
 */
export function Tabs({ tabs, active, onChange, className }: TabsProps): JSX.Element {
  return (
    <div role="tablist" className={clsx('flex gap-1 rounded-lg bg-paper-2 p-1', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={tab.id === active}
          className={clsx(
            'flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
            tab.id === active
              ? 'bg-white text-ink shadow-sm'
              : 'text-slate-500 hover:text-slate-700',
          )}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
